import { type MyFileRouter } from "@/app/(api)/api/uploadthing/core";
import { generateReactHelpers, generateUploadButton, generateUploadDropzone } from "@uploadthing/react";

export const UploadButton = generateUploadButton<MyFileRouter>();
export const UploadDropzone = generateUploadDropzone<MyFileRouter>();

export const { useUploadThing, uploadFiles, getRouteConfig } = generateReactHelpers<MyFileRouter>();
